import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { AuthRoute } from '@portal-core/auth/enums/auth-route.enum';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { AuthRouteService } from '@portal-core/auth/services/auth-route.service';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DefaultPageResolverService implements Resolve<string> {
  constructor(private authService: AuthService, private authRouteService: AuthRouteService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> {
    const authRoute = this.authService.isAuthenticated() ? AuthRoute.Home : AuthRoute.Login;

    // maintain return url
    const returnUrl = route.queryParams?.returnUrl;
    const navigationExtras = {
      replaceUrl: true,
      ...(returnUrl && { queryParams: { returnUrl } })
    };

    return this.authRouteService.navigateToAuthRoute$(authRoute, navigationExtras).pipe(
      map(() => authRoute)
    );
  }
}
